// #region Imports
import { safeNumber } from '../../../shared/helpers';
// #endregion

// #region Builders
export function buildVenda(partial = {}) {
  return {
    id: partial.id ?? null,
    data_hora: partial.data_hora ?? '',
    cliente_id: partial.cliente_id ?? null,
    funcionario_id: partial.funcionario_id ?? null,
    itens: Array.isArray(partial.itens) ? partial.itens.map(buildItem) : [],
    valor_total: safeNumber(partial.valor_total),
    is_fiado: !!partial.is_fiado,
    status: partial.status ?? 'FINALIZADA',
    observacoes: partial.observacoes ?? '',
  };
}

export function buildItem(partial = {}) {
  return {
    tipo: partial.tipo, // 'PRODUTO' | 'SERVICO'
    ref_id: partial.ref_id,
    nome: partial.nome,
    funcionario_id: partial.funcionario_id ?? null,
    quantidade: safeNumber(partial.quantidade || 1),
    preco_unit: safeNumber(partial.preco_unit || partial.preco),
    perc_comissao: safeNumber(
      partial.perc_comissao || partial.perc_comissao_padrao || 0,
    ),
  };
}
// #endregion

// #region Mapeadores / Serialização
export function vendaFromBackend(dto = {}) { return buildVenda(dto); }
export function vendaToJSON(v) { return { ...v, itens: v.itens.map(i => ({ ...i })) }; }
// #endregion

// #region Agregações
export function computeResumo(vendas = []) {
  let totalValor = 0;
  let finalizadas = 0;
  let pendentes = 0;
  vendas.forEach(v => {
    totalValor += v.valor_total || 0;
    if (v.status === 'FINALIZADA') finalizadas++; else pendentes++;
  });
  return { totalValor, finalizadas, pendentes };
}
// #endregion
